import React from 'react';
import Styles from '@/styles/PEIheadline.module.scss';

type props = {
  text: string;
};

export const PEIHeadLine = ({ text }: props) => {
  const [os, setOs] = React.useState('Windows');

  React.useEffect(() => {
    if (
      typeof window !== 'undefined' &&
      (navigator.userAgent.indexOf('Mac') !== -1 || navigator.userAgent.indexOf('Linux') !== -1)
    ) {
      setOs('Linux');
    } else if (
      typeof window !== 'undefined' &&
      (navigator.userAgent.indexOf('Android') !== -1 || navigator.userAgent.indexOf('iOS') !== -1)
    ) {
      setOs('Android');
    }
  }, []);

  return (
    <div className={Styles.main}>
      <span
        className={
          os === 'Windows'
            ? Styles.windowLeftLine
            : os === 'Android'
            ? Styles.androidLeftLine
            : Styles.leftLine
        }
      ></span>
      <h2 className={Styles.textStyle} data-testid='component-title-id'>
        {text}
      </h2>
    </div>
  );
};
